import { SidebarContentTrigger, SidebarHeader } from '@/components/ui/sidebar'
import { Undo2Icon } from 'lucide-react'

export function AppSidebarHeader() {
  return (
    <SidebarHeader className="p-0">
      <div className="flex items-center justify-between px-5 py-4">
        <h2 className="font-darkergrotesque text-xl font-bold">
          Preference
        </h2>
        <SidebarContentTrigger contentType='profile'>
          <Undo2Icon />
        </SidebarContentTrigger>
      </div>
    </SidebarHeader>
  )
}
